import { initHighChartsBlocks } from "./utils/utils";

const initInvestBlock = (containerEl) => {
    const processedAttr = 'data-invest-block-initialized';

    const setupBlock = (container) => {
        if (container.hasAttribute(processedAttr)) return;
        container.setAttribute(processedAttr, 'true');

        const backgroundImageValue = container.style.backgroundImage;

        if (backgroundImageValue && backgroundImageValue.startsWith('url(')) {
            container.style.setProperty('--invest-block-bg-image-url', backgroundImageValue);

            container.style.backgroundImage = '';
        }

        initHighChartsBlocks(container);
    };

    const setupAll = () => {
        document.querySelectorAll(containerEl).forEach(setupBlock);
    };

    setupAll();

    const observer = new MutationObserver(() => {
        setupAll();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener("DOMContentLoaded", initInvestBlock('.invest_block'));